import styled from 'styled-components'
import { Button } from '@rhinofi/dvf-shared-ui'
import type { ComponentProps } from 'react'

export const NoUnderlineAnchor = styled.a<{ $fullWidth?: boolean }>`
  text-decoration: none;
  ${({ $fullWidth }) => ($fullWidth ? 'width: 100%;' : '')}
`

type ExternalButtonLinkProps = {
  href: string
} & ComponentProps<typeof Button> &
  ComponentProps<typeof NoUnderlineAnchor>

export const ExternalButtonLink = (props: ExternalButtonLinkProps) => {
  return <Button as={NoUnderlineAnchor} {...props} />
}
